import React, { useMemo, useState } from 'react';
import { Box, Container, Paper, Stack, Tab, Tabs, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useSelector, shallowEqual } from 'react-redux';
import MiniDrawer from '../../components/MiniDrawer.js';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VitalsDashboard from './Dashboard/VitalsDashboard.js';

const VitalsRecordView = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const record = location.state?.record || null;
  const [tab, setTab] = useState('dashboard');
  const currentOrg = useSelector((state) => state.globalState.currentOrg, shallowEqual);

  const createdAtText = useMemo(() => {
    if (!record?.createdAt) return '--';
    const d = new Date(record.createdAt);
    if (Number.isNaN(d.getTime())) return '--';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${min}:${ss}`;
  }, [record?.createdAt]);

  if (!record) {
    return (
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Typography variant="h6">No record found.</Typography>
        <Box sx={{ mt: 2, cursor: 'pointer', color: '#29C0BB' }} onClick={() => navigate(-1)}>
          Back
        </Box>
      </Container>
    );
  }

  return (
    <Container disableGutters maxWidth={false}>
      <Grid container sx={{ overflow: 'auto', minHeight: '100vh', minWidth: '100vw' }}>
        <Grid size={{ xs: 1, md: 0.5 }}>
          <MiniDrawer />
        </Grid>
        <Grid size="grow">
          <Grid container spacing={5} sx={{ backgroundColor: '#F8F9FA', display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <Grid size={12}>
              <div style={{ paddingTop: 24, paddingBottom: 24 }}>
                <Grid container spacing={2} sx={{ padding: '0px 50px' }}>
                  <Grid size={12}>
                    <Typography variant="h5" sx={{ color: '#29C0BB', fontWeight: 'bold', mb: 2 }}>
                      <Box
                        component="span"
                        onClick={() => navigate(-1)}
                        sx={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 1 }}
                      >
                        <ArrowBackIcon fontSize="small" />
                        Back
                      </Box>
                    </Typography>

                    <Tabs
                        value={tab}
                        onChange={(_, v) => setTab(v)}
                        sx={{
                            mb: 2,
                            '& .MuiTab-root': {
                                color: '#000',
                                fontWeight: 'bold',
                            },
                            '& .MuiTab-root.Mui-selected': {
                                color: '#000',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#29C0BB',
                            },
                        }}
                    >
                      <Tab label="Dashboard" value="dashboard" />
                      <Tab label="Profile" value="profile" />
                    </Tabs>

                    {tab === 'dashboard' && (
                      <VitalsDashboard
                        mode="Corporates"
                        view="Vitals"
                        record={record}
                        currentOrg={currentOrg}
                      />
                    )}

                    {tab === 'profile' && (
                      <Paper elevation={1} sx={{ p: 3 }}>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Profile</Typography>
                        <Grid container spacing={3}>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>User ID</Typography>
                            <Typography>{record?.profile?.userId || record?.profile?.userTag || '--'}</Typography>
                          </Grid>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Sex</Typography>
                            <Typography>{record?.profile?.sex || record?.gender || '--'}</Typography>
                          </Grid>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Height</Typography>
                            <Typography>{record?.profile?.height ?? '--'}</Typography>
                          </Grid>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Weight</Typography>
                            <Typography>{record?.profile?.weight ?? '--'}</Typography>
                          </Grid>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Birth Year</Typography>
                            <Typography>{record?.profile?.birthYear ?? '--'}</Typography>
                          </Grid>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Blood Pressure Status</Typography>
                            <Typography>
                            {record?.profile?.bpStatus
                                ? `${record.profile.bpStatus.charAt(0).toUpperCase()}${record.profile.bpStatus.slice(1)}`
                                : '--'}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Created At</Typography>
                            <Typography>{createdAtText}</Typography>
                          </Grid>
                        </Grid>
                      </Paper>
                    )}
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default VitalsRecordView;